import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapAthleteWcupRankingComponent } from './components/bootstrap-athlete-wcup-ranking/bootstrap-athlete-wcup-ranking.component';
import { CommonPageComponentsModule } from 'src/app/common-page-components/common-page-components.module';
import { ComponentsModule } from 'world-archery-lib';
import { AthleteWcupRankingRoutingModule } from "./athlete-wcup-ranking-routing.module";
import { AthleteResultsWcupRankingTableComponent } from './components/athlete-results-wcup-ranking-table/athlete-results-wcup-ranking-table.component';
import { AthleteGeneralTableWcupRankingTableComponent } from './components/athlete-general-table-wcup-ranking-table/athlete-general-table-wcup-ranking-table.component';
import { AthleteFinalsTableWcupRankingTableComponent } from './components/athlete-finals-table-wcup-ranking-table/athlete-finals-table-wcup-ranking-table.component';


@NgModule({
  declarations: [BootstrapAthleteWcupRankingComponent, AthleteResultsWcupRankingTableComponent, AthleteGeneralTableWcupRankingTableComponent, AthleteFinalsTableWcupRankingTableComponent],
  imports: [
    CommonModule,
    CommonPageComponentsModule,
    ComponentsModule,
    AthleteWcupRankingRoutingModule
  ],
  providers: [

  ]
})
export class AthleteWcupRankingModule { }
